import React from "react";
import styles from "./QuizAudience.module.css";

const cards = [
  {
    icon: "/img/teaching.webp", // 🧑‍🎓
    title: "Content Creators & Publishers",
    img: "/img/PrepAI-Dash-1.webp",
  },
  {
    icon: "/img/student.webp", // 🧑‍🎓 (HR)
    title: "Agencies with Ed-Tech Clients",
    img: "/img/PrepAi-Dash-2.webp",
  },
  {
    icon: "/img/school.webp", // 🏢
    title: "Course Builders & Educators",
    img: "/img/PrapAi-Dash-3.webp",
  },
  {
    icon: "/img/human-resources.webp", // 📝
    title: "Video Educators & Reviewers",
    img: "/img/Tutors-PrepAI.webp",
  },
  {
    icon: "/img/building.webp", // 🏫
    title: "Part/Full-time Affiliate Marketers",
    img: "/img/Edu-Ins-PrepAI.webp",
  },
];

const QuizAudience = () => {
  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>
        Is The PrepAI Affiliate Program Your Perfect Fit?
        <br />
        Who is it for?
      </h2>
      <p className={styles.description}>
        If you've got a voice, a network, or a passion for sharing promising
        edtech platforms and turning it into income, this program's for you.
      </p>
      <div className={styles.grid}>
        <div className={styles.gridLeft}>
          {cards.slice(0, 3).map((card, idx) => (
            <div className={styles.leftCard} key={card.title}>
              <div className={styles.leftCardContent}>
                <div className={styles.icon}>
                  <img
                    src={card.icon}
                    alt={card.title}
                    className={styles.img}
                  />
                </div>
                <div className={styles.title}>{card.title}</div>
              </div>
              <div className={styles.imgWrap}>
                <img src={card.img} alt={card.title} className={styles.img} />
              </div>
            </div>
          ))}
        </div>
        <div className={styles.gridRight}>
          {cards.slice(3).map((card, idx) => (
            <div className={styles.rightCard} key={card.title}>
              <div className={styles.leftCardContent}>
                <div className={styles.icon}>
                  <img
                    src={card.icon}
                    alt={card.title}
                    className={styles.img}
                  />
                </div>
                <div className={styles.title}>{card.title}</div>
              </div>
              <div className={styles.imgWrap}>
                <img src={card.img} alt={card.title} className={styles.img} />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div></div>
    </section>
  );
};

export default QuizAudience;
